<template>
  <div class="onboarding-select">
    <button
      type="button"
      class="onboarding-select__trigger"
      :class="{ 'onboarding-select__trigger--open': open }"
      @click="toggle">
      <span v-if="selectedLabel" class="onboarding-select__value">{{ selectedLabel }}</span>
      <span v-else class="onboarding-select__placeholder">{{ placeholder }}</span>
      <svg
        class="onboarding-select__caret"
        viewBox="0 0 12 12"
        aria-hidden="true">
        <path
          d="M3 4.5l3 3 3-3"
          stroke="currentColor"
          stroke-width="1.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <div
      v-show="open"
      class="onboarding-select__menu"
      role="listbox">
      <template v-for="(group, gi) in normalizedGroups">
        <div
          v-if="gi > 0"
          :key="`divider-${gi}`"
          class="onboarding-select__divider"
          aria-hidden="true" />
        <button
          v-for="opt in group.items"
          :key="opt[valueKey]"
          type="button"
          role="option"
          class="onboarding-select__option"
          :class="{ 'onboarding-select__option--active': isSelected(opt) }"
          @click="choose(opt)">
          {{ opt[labelKey] }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingSelect',
  props: {
    value: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Selecione…'
    },
    labelKey: {
      type: String,
      default: 'text'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    grouped: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    normalizedGroups () {
      if (this.grouped) return this.options
      return [{ items: this.options }]
    },
    selectedLabel () {
      return this.value && this.value[this.labelKey]
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.handleDocumentClick)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.handleDocumentClick)
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    close () {
      this.open = false
    },
    choose (opt) {
      this.$emit('input', opt)
      this.close()
    },
    isSelected (opt) {
      return this.value && this.value[this.valueKey] === opt[this.valueKey]
    },
    handleDocumentClick (event) {
      if (!this.$el.contains(event.target)) this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.onboarding-select {
  position: relative;

  &__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
    line-height: 1.4;
    color: #111827;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.15s ease;
    text-align: left;

    &:hover {
      border-color: #d1d5db;
    }

    &:focus,
    &--open {
      outline: none;
      border-color: #c7c9d9;
    }
  }

  &__value {
    flex: 1;
  }

  &__placeholder {
    flex: 1;
    color: #9ca3af;
  }

  &__caret {
    width: 14px;
    height: 14px;
    color: #9ca3af;
    transition: transform 0.15s ease;
    flex-shrink: 0;
  }

  &__trigger--open .onboarding-select__caret {
    transform: rotate(180deg);
  }

  &__menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    max-height: 280px;
    overflow-y: auto;
    padding: 4px 0;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }

  &__option {
    display: block;
    width: 100%;
    padding: 8px 14px;
    font-size: 0.9rem;
    line-height: 1.4;
    color: #111827;
    background: transparent;
    border: none;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.1s ease;

    &:hover {
      background-color: #f5f5fb;
    }

    &--active {
      font-weight: 600;
      background-color: #dbeafe;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e5e7eb;
    margin: 6px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Onboarding/OnboardingSelect.vue